<fieldset>
  <div class="form-group" [class.row]="!detailViewComponent.smallScreen">
    <label
      class="col-form-label"
      [class.col-5]="!detailViewComponent.smallScreen"
      [class.text-right]="!detailViewComponent.smallScreen"
      [class.required]="prop.field_required"
    >
      {{ prop.field_label | translate }}
    </label>
    <div [class.col-7]="!detailViewComponent.smallScreen">
      <div class="input-group input-group-sm" [class.required-field-border]="prop.field_required">
        <select
          class="form-control"
          [class.disabled-color]="!prop.field_editable"
          #selectComponentRef
          [id]="prop.field_id"
          [name]="prop.field_name"
          [formControl]="graphicFormGroup.controls[prop.field_name]"
          (change)="onChange($event)"
        >
          <option
            *ngFor="let opt of prop.opts"
            [value]="opt.value"
            [selected]="
              opt.value === detailFormDataModel.selectedFeature.attributes[prop.field_name]
            "
          >
            {{ opt.label }}
          </option>
        </select>

        <div
          *ngIf="prop.field_required"
          class="input-group-append required-field-block required-field-border"
        >
          <span class="input-group-text" id="basic-addon2">*</span>
        </div>
      </div>
      <error-tooltip [errorMessages]="errorMessages"></error-tooltip>
    </div>
  </div>
</fieldset>
